import { ReactNode } from "react";

import { ProgressBar } from "@smart/itops-sb-design-system-dom";

type HeadingProps = {
  nav?: ReactNode;
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  loading?: boolean;
  className?: string;
  variant?: "default" | "intake";
};

const Heading = ({
  nav,
  left,
  center,
  right,
  loading,
  className,
  variant = "default",
}: HeadingProps) => {
  const isIntakeVariant = variant === "intake";

  return (
    <div className={className}>
      {nav && (
        <div className="flex items-center px-8 py-[0.6rem] bg-white border-b border-neutral-100 z-1 min-h-[5rem]">
          {nav}
        </div>
      )}
      <div
        className={`bg-white flex items-center px-8 py-4 relative ${
          isIntakeVariant
            ? "shadow-none border-b border-neutral-200 h-28 z-1"
            : "shadow-[0px_1px_3px_0px_rgba(0,0,0,0.15)] z-2"
        }`}
        data-testid="heading-wrapper"
      >
        <div className="flex flex-[1_1] w-[30rem] justify-start">{left}</div>
        {center && <div className="flex flex-1 justify-center">{center}</div>}
        <div className="flex flex-[1_1] w-[30rem] justify-end">{right}</div>
        {loading && <ProgressBar overlay className="h-[0.3rem]" />}
      </div>
    </div>
  );
};

export { Heading, HeadingProps };
